import { Resource } from 'kolibri.lib.apiResource';

export default new Resource({
  name: 'examlog',
});
